<template>
  <hb-modal
    v-model="show"
    size="medium"
    @close="onClose"
    title="Remove from Do Not Rent"
    confirmation
  >
    <template v-slot:content>
      <v-row class="ma-0 px-2 py-5">
        <v-col cols="12">
          You are about to remove the following contacts from the Do Not Rent
          list
        </v-col>
        <v-col
          cols="12"
          class="py-1"
          v-for="(contact, index) in contactsList"
          :key="index"
        >
          <strong>
            {{ contact.tenant_name }} | {{ contact.tenant_phone | formatPhone }} | {{ contact.tenant_email }}
          </strong>
        </v-col>
        <v-col cols="12">
          Are you sure you want to remove these contacts?
        </v-col>
      </v-row>
    </template>
    <template v-slot:right-actions>
      <span class="">
        <hb-btn
          class="mr-1"
          color="primary"
          type="submit"
          :loading="btnLoader"
          :disabled="btnLoader"
          @click="remove"
          >Remove</hb-btn
        >
      </span>
    </template>
  </hb-modal>
</template>

<script>
export default {
  name: "RemoveContactModal",
  data() {
    return {};
  },
  props: ["show", "contactsList", "removeContact", "onClose", "btnLoader"],

  methods: {
    remove() {
      this.$emit("removeContact", this.contactsList);
    },
  },
  watch: {
    // Watch the clear prop for changes
  },
};
</script>

<style scoped></style>
